export enum Screens {
  Large = "(min-width: 600px)",
}
